import { connect } from 'react-redux'
import { WELCOME_PROMPT_HIDDEN } from 'aria-viewer/tour/constants/queryConstants'
import { submitButtonClick } from '../registrationActions'
import SubmitButton from '../components/SubmitButton'
import qs from 'qs'

const mapStateToProps = state => {
    const linkURLQuery = qs.stringify({
        ...state.get('routing').location.query,
        [WELCOME_PROMPT_HIDDEN]: 1,
    })

    return {
        linkURL: `${state.get('routing').location.pathname}?${linkURLQuery}`.replace('//', '/'), // Add replace '//' with '/' to avoid Security Error being thrown when replacing history state
        replace: state.get('routing').location.query[WELCOME_PROMPT_HIDDEN] == 1,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: e => {
        const { handleClick } = ownProps
        handleClick && handleClick(e)

        dispatch(submitButtonClick())
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubmitButton)
